import type { AppLocale } from '@/urls'

export const nb = {
    _prefix: '',
    _locale: 'nb' as AppLocale,

    breadcrumbs: {
        mineArbeidsforhold: 'Mine arbeidsforhold',
        arbeidssted: 'Arbeidssted',
        arbeidsforhold: 'Arbeidsforhold',
    },

    filter: {
        alle: 'Alle',
        aktive: 'Aktive',
        avsluttede: 'Avsluttede',
        fremtidige: 'Fremtidige',
        ikkeValgt: 'Ikke valgt',
        ingenTreff: 'Ingen treff',
        soekEtterNavn: 'Søk etter navn',
        periode: 'Status',
        viserAntall: 'Viser %s av %s arbeidsforhold',
        sorterEtter: 'Sorter etter',
        sorterNavn: 'Navn (A–Å)',
        sorterStartdato: 'Startdato (nyeste først)',
        sorterSluttdato: 'Sluttdato (nyeste først)',
        sorterStillingsprosent: 'Stillingsprosent (høyest først)',
        sorterYrke: 'Yrke (A–Å)',
    },

    term: {
        arbeidstaker: 'Arbeidstaker',
        arbeidssted: 'Arbeidssted',
        rapporteringsordning: 'Rapporteringsordning',
        arbeidsforholdstatus: 'Arbeidsforholdstatus',
        arbeidsforholdtype: 'Arbeidsforholdstype',
        foedselsnummer: 'Fødselsnummer',
        navn: 'Navn',
        organisasjonsnummer: 'Organisasjonsnummer',
        organisasjonsnavn: 'Organisasjonsnavn',
        stillingsprosent: 'Stillingsprosent',
        startdato: 'Startdato',
        sluttdato: 'Sluttdato',
        yrke: 'Yrke',
        arbeidsforhold: 'Arbeidsforhold',
    },

    detaljer: {
        arbeidstaker: 'Offentlig ident',
        ansettelsesperiode: 'Ansettelsesperiode',
        hovedenhet: 'Hovedenhet',
        underenhet: 'Underenhet',
        opplysningspliktig: 'Opplysningspliktig',
        organisasjonsnummer: 'Organisasjonsnummer %s',
        yrke: 'Yrke',
        yrkeskode: 'Yrkeskode',
        arbeidsforholdstype: 'Arbeidsforholdstype',
        arbeidsforholdId: 'Arbeidsforhold ID',
        arbeidstidsordning: 'Arbeidstidsordning',
        ansettelsesform: 'Ansettelsesform',
        avtaltStillingsprosent: 'Stillingsprosent',
        sisteStillingsprosentEndring: 'Endret stillingsprosent',
        sisteLonnsendring: 'Siste lønnsendring',
        antallTimerPrUke: 'Timer per uke',
        sistBekreftet: 'Sist bekreftet av opplysningspliktig',
        sluttaarsak: 'Sluttårsak',
        sluttaarsakMedVerdi: '(Sluttårsak: %s)',
        fartsomraade: 'Fartsområde',
        skipsregister: 'Skipsregister',
        fartoeystype: 'Fartøystype',
        omArbeidsforholdet: 'Om arbeidsforholdet',
        opprettet: 'Opprettet',
        sistEndret: 'Sist endret',
        visEndringer: 'Vis endringer i arbeidsforholdet',
        antallEndringer: '%s endringer',
        enEndring: '1 endring',
        visAlleEndringer: 'Vis alle %s endringer',
        omRapporteringen: 'Om rapporteringen',
        viserForDato: 'Viser arbeidsforholdet slik det så ut %s',
        tilbakestillDato: 'Tilbakestill til gjeldende dato',
        mangler: 'mangler',
    },

    tabs: {
        arbeidiutlandet: 'Arbeid i utlandet',
        historikk: 'Historikk',
        permisjonpermittering: 'Permisjon/Permittering',
        timerfortimelonnet: 'Timer for timelønnet',
    },

    loading: {
        laster: 'Laster...',
        henterArbeidsforhold: 'Henter arbeidsforhold...',
        hentArbeidsforholddetaljer: 'Henter arbeidsforholdsdetaljer...',
        hentPermisjoner: 'Henter permisjoner',
        hentPermitteringer: 'Henter permitteringer',
        hentUtenlandsopphold: 'Henter utenlandsopphold',
        hentTimerMedTimeloenn: 'Henter timer med timelønn',
    },

    permisjon: {
        permisjon: 'Permisjon',
        type: 'Permisjonstype',
        periode: 'Periode',
        prosent: 'Prosent',
        id: 'PermisjonsID',
        ingenTreff: 'Fant ingen permisjoner',
    },

    permittering: {
        permittering: 'Permittering',
        type: 'Permitteringstype',
        periode: 'Periode',
        prosent: 'Prosent',
        id: 'PermitteringsID',
        ingenTreff: 'Fant ingen permitteringer',
    },

    timerForTimeloennet: {
        timerForTimeloennet: 'Timer med timelønn',
        rapporteringsmaaned: 'Rapporteringsmåned',
        rapporteringsperiode: 'Periode',
        opptjeningsperiode: 'Opptjeningsperiode',
        antallTimer: 'Antall timer',
        ingenTreff: 'Fant ingen timer med timelønn',
    },

    utenlandsopphold: {
        utenlandsopphold: 'Utenlandsopphold',
        rapporteringsmaaned: 'Rapporteringsmåned',
        rapporteringsperiode: 'Periode',
        land: 'Land',
        opptjeningsperiode: 'Opptjeningsperiode',
        ingenTreff: 'Fant ingen utenlandsopphold',
    },

    historikk: {
        historikk: 'Historikk',
    },

    varsel: {
        ERKONK: 'Arbeidsgiveren har gått konkurs. Nav har satt samme sluttdato som konkursåpningsdato i Konkursregisteret.',
        EROPPH: 'Foretaket er opphørt i Enhetsregisteret. Nav har satt samme sluttdato som datoen foretaket opphørte i Enhetsregisteret.',
        ERVIRK: 'Foretaket er overdratt til en annen juridisk enhet. Nav har satt samme sluttdato som datoen da foretaket ble overdratt i Enhetsregisteret.',
        IBARBG: 'Arbeidsgiveren har ikke bekreftet arbeidsforholdet. Nav har derfor satt sluttdato til siste dato i den kalendermåneden arbeidsgiveren din sist bekreftet arbeidsforholdet.',
        IBKAOR: 'Sluttdato satt av Nav. Arbeidsforholdet er ikke bekreftet gjennom a-ordningen. Sluttdato er satt til 31.12.2014',
    },

    knapp: {
        loggInn: 'Logg inn',
        lagre: 'Lagre',
        fortsett: 'Fortsett',
        avbryt: 'Avbryt',
        nullstillValg: 'Nullstill valg',
        lastNedPdf: 'Last ned PDF',
        lastNedExcel: 'Last ned Excel',
        skrivUtPdf: 'Skriv ut PDF',
        tilbake: 'Tilbake til oversikten',
        endreDataelementer: 'Endre dataelementer',
        velgDato: 'Velg dato',
        velgMaaned: 'Velg måned',
        soek: 'Søk',
    },

    dataminimering: {
        velgDataelementer: 'Endre valg av dataelementer',
        beskrivelse:
            'Kun de valgte dataelementene vil bli hentet og vist. Velg utelukkende de dataelementene du har behov for i henhold til ditt behandlingsgrunnlag.',
        dataelementer: 'Dataelementer',
        grupper: {
            ansettelse: 'Ansettelse',
            arbeidstidOgLoenn: 'Arbeidstid og lønn',
            historikkOgFravaer: 'Historikk og fravær',
            maritimt: 'Maritimt',
        },
    },

    soek: {
        hvaVilDuSoekePaa: 'Hva vil du søke på?',
        identLabel: 'Fødselsnummer, D-nummer eller organisasjonsnummer',
        skrivInnFnr: 'Skriv inn fnr/dnr',
        skrivInnOrgnr: 'Skriv inn orgnr/fnr/dnr',
        antallValgt: '%s valgt',
        rapporteringsordning: {
            A_ORDNINGEN: 'A-ordningen',
            FOER_A_ORDNINGEN: 'Før a-ordningen',
        },
        arbeidsforholdstatus: {
            AKTIV: 'Aktiv',
            FREMTIDIG: 'Fremtidig',
            AVSLUTTET: 'Avsluttet',
        },
        arbeidsforholdtype: {
            ordinaertArbeidsforhold: 'Ordinært',
            maritimtArbeidsforhold: 'Maritimt',
            frilanserOppdragstakerHonorarPersonerMm: 'Frilanser m.m.',
            forenkletOppgjoersordning: 'Forenklet',
        },
    },

    feil: {
        pdf: 'Kunne ikke lage PDF',
        excel: 'Kunne ikke lage Excel',
        fantIkke: {
            navn: '(Navn mangler)',
            arbeidsforholdsdetaljer: 'Fant ikke arbeidsforholdsdetaljer',
            permisjon: 'Fant ingen permisjoner',
            permittering: 'Fant ingen permitteringer',
            timerMedTimeloenn: 'Fant ingen timer med timelønn',
            utenlandsopphold: 'Fant ingen utenlandsopphold',
        },
        validering: {
            soek: {
                arbeidssted: 'Må være 9 eller 11 siffer',
                arbeidstaker: 'Må være 11 siffer',
                rapporteringsordning: 'Du må velge minst én rapporteringsordning',
                arbeidsforholdstatus: 'Du må velge minst én arbeidsforholdstatus',
                arbeidsforholdtype: 'Du må velge minst én arbeidsforholdtype',
            },
        },
    },

    tabell: {
        viserAvTotalt: 'Viser %start - %slutt av totalt %total resultater',
        rader: 'Rader',
        visAlle: 'Vis alle (%s)',
        visFlere: 'Vis flere (%s)',
        visMindre: 'Vis mindre',
        lukkAlleRader: 'Lukk alle rader',
        utvidAlleRader: 'Utvid alle rader',
        velgAlleRader: 'Velg alle rader',
    },

    excel: {
        info: 'Info',
        omDokumentet: 'Om dokumentet',
        generertAv: 'Generert av Arbeidsgiver- og arbeidstakerregisteret.',
        dato: 'Dato',
        antallArbeidsforhold: 'Antall arbeidsforhold',
        beskrivelse:
            'Denne Excel-filen inneholder en oversikt over aktive og avsluttede arbeidsforhold for den valgte arbeidstakeren, slik de er rapportert til Arbeidsgiver- og arbeidstakerregisteret etter 01.01.2015. \n Hvis det er feil i et arbeidsforhold, skal du som arbeidsgiver endre dette gjennom a-meldingen.',
        aktiveArbeidsforhold: 'Aktive arbeidsforhold',
        avsluttedeArbeidsforhold: 'Avsluttede arbeidsforhold',
        varsel: 'Varsel',
    },

    pdf: {
        footer1: 'Oversikten viser arbeidsforholdene slik de er rapportert til Arbeidsgiver- og arbeidstakerregisteret',
        footer2: 'Arbeids- og velferdsetaten // Utskrift fra %s',
        detaljerOmArbeidsforholdet: 'Detaljer om arbeidsforholdet',
        opplysningspliktig: 'Opplysningspliktig',
        timerPerUkeIFullStilling: 'Timer per uke i full stilling',
        foerstRapportert: 'Først rapportert av opplysningspliktig',
        sistRapportert: 'Sist rapportert av opplysningspliktig',
        arbeidsforholdSistEndret: 'Arbeidsforhold ble sist endret',
        permisjoner: 'Permisjoner',
        ingenRegistrertePermisjoner: 'Ingen registrerte permisjoner.',
        permitteringer: 'Permitteringer',
        ingenRegistrertePermitteringer: 'Ingen registrerte permitteringer.',
        ingenRegistrertArbeidIUtlandet: 'Ingen registrert arbeid i utlandet.',
        rapporteringsmaaned: 'Rapporteringsmåned',
        ingenRegistrerteTimerMedTimeloenn: 'Ingen registrerte timer med timelønn.',
        ingenRegistrerteEndringer: 'Ingen registrerte endringer.',
        endretTil: 'Endret til',
        av: 'av',
        periode: 'Periode',
        stillingsprosentendring: 'Stillingsprosentendring',
        antallTimerPerUke: 'Antall timer per uke',
        id: 'ID',
        utskrift: 'Utskrift',
        side: 'Side',
        timerPerUkeEnhet: 'timer per uke',
        lonnsendring: 'Lønnsendring',
        typeArbeidsforhold: 'Type arbeidsforhold',
    },

    info: {
        hvisfeil1: 'Oversikten viser arbeidsforholdene slik det er rapportert av arbeidsgiver.',
        hvisfeil2: 'Hvis det er feil i et arbeidsforhold, kan arbeidsgiveren endre gjennom a-meldingen.',
        ingenArbeidsforhold: 'Du har ingen registrerte arbeidsforhold.',
        opplysningIkkeValgt: 'Opplysning ikke valgt',
        ingenData: 'Ingen data',
    },

    landing: {
        loggInn: 'Logg inn',
        arbeidstaker: {
            heading: 'Innsyn i Aa-registeret for arbeidstaker',
            body: 'Logg inn for å få oversikt over alle arbeidsforhold som dine arbeidsgivere har rapportert inn på deg via A-meldingen.',
            linkArbeidsgiverTitle: 'Se tjenester som arbeidsgiver',
            linkArbeidsgiverDescription: 'Gå til innloggede sider',
        },
        arbeidsgiver: {
            heading: 'Innsyn i Aa-registeret for arbeidsgiver',
            body: 'Logg inn for å få oversikt over alle arbeidsforhold du som arbeidsgiver har rapportert inn via A-meldingen.',
            linkTilgangTitle: 'Hvordan får jeg tilgang?',
            linkTilgangDescription: 'Les mer om tilgangsstyring i Altinn',
            linkPrivatTitle: 'Se tjenester som privatperson',
            linkPrivatDescription: 'Gå til innloggede sider',
        },
        samarbeidspartner: {
            heading: 'Innsyn i Aa-registeret for samarbeidspartner',
            introBefore: 'Alle som har ',
            introLink: 'søkt',
            introAfter: ' om og fått innvilget tilgang, kan benytte tjenesten.',
            introLine2:
                'Her kan du foreta oppslag enten på arbeidsgiver (organisasjonsnummer) eller arbeidstaker (Fødselsnummer/D-nummer).',
            subheading: 'Nærmere beskrivelse av tjenesten:',
            brukerveiledningBefore: 'Her finner du ',
            brukerveiledningLink: 'brukerveiledning til tjenesten',
            brukerveiledningAfter: '.',
            gratis: 'Tjenesten er gratis å benytte.',
            sperretAdresse: 'Opplysninger om personer med sperret adresse etter folkeregisterloven §10-4 utleveres ikke.',
            utloggetInaktivitet: 'Du blir utlogget etter inaktivitet i ????? timer.',
            dataminimering:
                'Dine valg for dataminimering og filtrering lagres innenfor påloggingen, men må gjennomføres på nytt ved neste pålogging.',
            driftsvarslerBefore: 'Du kan følge med på ',
            driftsvarslerLink: 'nyheter og driftsvarsler',
            driftsvarslerAfter: ' knyttet til tjenesten.',
            infoBoxTitle: 'Tildeling av tilgang foregår i Altinn',
            infoBoxLink: 'Les mer her',
        },
    },

    ingenTilgang: {
        arbeidsgiver: {
            heading: 'Innsyn i Aa-registeret for arbeidsgiver',
            body: 'Her finner du oversikt over alle arbeidsforhold som er rapportert inn via A-meldingen.',
            ikkeTilgangTitle: 'Du har ikke tilgang til tjenesten',
            aarsakerIntro: 'Det kan være flere årsaker til at du ikke har tilgang:',
            aarsak1: 'Du har ikke fått delegert fullmakt til tjenesten i Altinn av virksomhetens hovedadministrator eller tilgangsstyrer.',
            aarsak2: 'Du har ikke en rolle i enhetsregisteret som gir tilgang til denne tjenesten.',
            hvordanTilgangTitle: 'Hvordan får jeg tilgang?',
            hvordanTilgangBodyBefore:
                'For å få tilgang til innsynstjeneste for arbeidsforhold innrapportert via a-meldingen trenger du enkelttjenesten «Innsyn i Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret) for arbeidsgivere» i ',
            hvordanTilgangBodyLink: 'Altinn',
            hvordanTilgangBodyAfter: '.',
            hvordanTilgangRollerIntro: 'Tilgang gis også automatisk til personer med følgende roller i enhetsregisteret:',
            hvordanTilgangRoller: [
                'daglig leder/administrerende direktør',
                'styreleder',
                'innehaver av enkeltpersonsforetak',
                'deltaker i ansvarlig selskap (ANS og DA)',
                'bestyrende reder',
                'bostyrer i konkursbo (omfatter ikke virksomheten som er gått konkurs) og andre bo',
                'komplementar (kun fødselsnummer)',
                'norsk representant for utenlandsk enhet',
            ],
            linkPrivatTitle: 'Se tjenester som privatperson',
            linkPrivatDescription: 'Gå til innloggede sider',
            linkTilgangTitle: 'Hvordan får jeg tilgang?',
            linkTilgangDescription: 'Les mer om tilgangsstyring i Altinn',
        },
        samarbeidspartner: {
            heading: 'Innsyn i Aa-registeret for samarbeidspartner',
            body: 'Her finner du oversikt over arbeidsforhold som er rapportert inn via A-meldingen.',
            ikkeTilgangTitle: 'Du har ikke tilgang til tjenesten',
            aarsakerIntro: 'Det kan være flere årsaker til at du ikke har tilgang:',
            aarsak1: 'Du er ikke delegert tilgang i Altinn av en administrator.',
            aarsak2: 'Dine roller og tilganger i Altinn gir ikke tilgang til denne tjenesten.',
            linkTilgangTitle: 'Hvordan får jeg tilgang?',
            linkTilgangDescription: 'Les mer om tilgangsstyring i Altinn',
        },
    },

    bruksvilkaar: {
        heading: 'Bruksvilkår',
        velkommen: 'Velkommen til web-oppslagsløsningen for Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret).',
        forBenytte: 'For å benytte tjenesten må du være klar over følgende:',
        taushetspliktLine1:
            'Alle opplysningene i Aa-registeret er underlagt lovbestemt taushetsplikt, jf. forskrift om Aa-registeret § 16. Du plikter å ha gjort deg kjent med hva dette innebærer før du benytter tjenesten. Ved å krysse av for at du har lest og forstått bruksvilkårene bekrefter du at du er kjent med taushetsplikten og at du forplikter deg til å etterleve denne.',
        taushetspliktLine2Before:
            'Du finner mer informasjon om taushetsplikten og hva den innebærer i bruksvilkårene din virksomhet har godkjent og forpliktet seg til å etterleve i kapittel 10 ',
        taushetspliktLine2Link: 'her',
        taushetspliktLine2After: '.',
        taushetspliktLine3: 'Brudd på taushetsplikten kan straffes med bøter eller med fengsel i inntil 1 år, se straffeloven §209.',
        dataminimeringLine1:
            'Du er forpliktet til å ikke gjøre oppslag på, eller hente ut, flere dataelementer fra Aa-registeret enn det som er nødvendig ut fra hvilket formål som er innvilget, herunder hva som er ditt tjenstlige behov.',
        dataminimeringLine2:
            'Din arbeidsgiver har i forbindelse med søknaden om tilgang til Aa-registeret oppgitt hvilke dataelementer som er nødvendige å gjøre oppslag på ut fra hva som er formålet for tilgangen for din virksomhet. Dersom du opplever at det er behov for å benytte flere dataelementer enn disse, så må din arbeidsgiver søke om å få utvidet tilgangen tilsvarende. Vi må ha godkjent denne søknaden før det gjøres lovlig oppslag. Dersom du ikke vet hvilke dataelementer din arbeidsgiver har oppgitt som nødvendige, ta kontakt med din arbeidsgiver før du benytter deg av tjenesten.',
        uforenelig: 'Opplysningene kan ikke brukes til formål som er uforenelige med det opprinnelige formålet (uberettiget oppslag).',
        logging:
            'Alle oppslag blir logget på system- og personnivå, og kan spores i ettertid. Den registrerte har som utgangspunkt rett til å få innsyn i slike logger om de ber om dette. NAV har rett til å benytte disse loggene som grunnlag dersom det mistenkes uberettiget oppslag.',
        avslutningBefore:
            'Vi anbefaler deg å sette deg inn i de øvrige bruksvilkårene som din virksomhet har godkjent og forpliktet seg til å etterleve for å kunne gjøre bruk av tjenesten. Her finner du ',
        avslutningLink: 'generelle bruksvilkår',
        avslutningAfter: ' for bruk av Aa-registeret.',
        checkboxLabel: 'Jeg har lest og forstått bruksvilkårene',
        godtaButton: 'Godta vilkår',
    },

    arbeidsgiverHovedenhet: {
        underenheterInfo: 'Oversikten viser underenheter som du har tilgang til og hvor det er rapportert arbeidsforhold.',
        undetenheterInfo2:
            'Det kan finnes flere underenheter på denne hovedenheten som ikke vises i listen fordi du ikke har tilgang til tjenesten eller det aldri har vært rapportert ansatte.',
        clearUnderenhetButtonLabel: 'Tøm søkefelt',
        sokPlaceholder: 'Søk på underenhet...',
        sokLabel: 'Søk på underenhet',
        ingenUnderenheter: 'Virksomheten har ingen underenheter med rapporterte arbeidsforhold',
        fantIkkeUnderenhet: 'Fant ingen underenheter som tilsvarer søket ditt',
        lesMer: 'Om oversikten',
        merkelapp: 'Hovedenhet',
        sorterArbeidsforhold: 'Antall arbeidsforhold (flest først)',
        viserAntall: 'Viser %s av %s underenheter',
        visFlere: 'Vis flere underenheter',
    },
    underenhetTableRow: {
        copyIdent: 'Kopier organisasjonsnummer for ',
        aktiveArbForhold: 'aktive arbeidsforhold',
        inaktiveArbForhold: 'inaktive arbeidsforhold',
    },

    kopier: {
        fnrMedNavn: 'Kopier fødselsnummer for %s',
        orgnrMedNavn: 'Kopier organisasjonsnummer for %s',
        fnr: 'Kopier fødselsnummer',
        orgnr: 'Kopier organisasjonsnummer',
    },

    hjelpetekst: {
        om: 'Om %s?',
        arbeidssted: 'Underenheten arbeidstakeren er ansatt i. For en personlig arbeidsgiver er arbeidsstedet personen selv.',
        opplysningspliktig:
            'Den som har plikt til å rapportere opplysninger om arbeidsforholdet, i praksis gjennom a-meldingen. For en organisasjon er dette hovedenheten, for en personlig arbeidsgiver personen selv.',
        startdato: 'Datoen arbeidsforholdet starter ifølge arbeidsavtalen. Startdatoen trenger ikke være den samme som første dag på jobb.',
        sluttdato:
            'Datoen arbeidsforholdet opphører. Sluttdatoen er ikke alltid den siste dagen arbeidstakeren møter på jobb, fordi arbeidsforholdet ikke er formelt avsluttet før for eksempel turnusperioden er over eller avspaseringsdager er tatt ut.',
        sluttaarsak: 'Årsaken til at arbeidsforholdet ble avsluttet.',
        yrke: 'Kombinasjonen av yrkestittel og yrkeskode. Yrkeskoden er en sjusifret kode i yrkeskatalogen som Statistisk sentralbyrå forvalter, og bestemmes av arbeidsoppgavene arbeidstakeren faktisk utfører – ikke av utdanningsnivå eller stillingstype.',
        avtaltStillingsprosent: 'Prosentandelen arbeidstakerens avtalte arbeidstid utgjør av det som er fulltid for tilsvarende stilling.',
        sisteStillingsprosentEndring: 'Datoen stillingsprosenten sist ble endret.',
        antallTimerPrUke:
            'Antall timer per uke som utgjør en 100 % stilling. Brukes blant annet til å beregne stillingsprosent for arbeidstakere som jobber deltid.',
        ansettelsesform: 'Om arbeidstakeren er fast eller midlertidig ansatt.',
        arbeidstidsordning: 'Avtale om når på døgnet arbeidet skal skje, og eventuelle variasjoner i denne over en periode.',
        sisteLonnsendring: 'Datoen arbeidstakeren sist fikk endret lønn.',
        fartsomraade: 'Det avgrensede området det maritime arbeidsforholdet finner sted i, enten innenriksfart eller utenriksfart.',
        skipsregister:
            'Registeret det maritime fartøyet er registrert i: NOR (Norsk ordinært skipsregister), NIS (Norsk internasjonalt skipsregister) eller UTLA (utenlandsk registrert fartøy).',
        fartoeystype: 'Typen sjøgående fartøy det maritime arbeidsforholdet finner sted på, for eksempel turistskip eller boreplattform.',
        opprettet: 'Tidspunktet arbeidsforholdet ble opprettet i Aa-registeret.',
        sistEndret: 'Tidspunktet Nav sist mottok og utførte en endring i ett eller flere datafelt i arbeidsforholdet.',
        sistBekreftet:
            'Tidspunktet den sist mottatte a-meldingen om arbeidsforholdet ble behandlet. Den opplysningspliktige bekrefter arbeidsforholdet ved å sende a-melding.',
        rapporteringsordning:
            'Angir om arbeidsforholdet er rapportert gjennom a-ordningen, som ble innført 01.01.2015, eller gjennom den tidligere rapporteringsordningen.',
        arbeidsforholdId:
            'Identifikator som skiller de enkelte arbeidsforholdene fra hverandre når arbeidstakeren eller frilanseren har flere arbeidsforhold i samme underenhet.',
        permisjon: {
            periode: 'Perioden arbeidstakeren er i permisjon, angitt med første og siste permisjonsdag.',
            type: 'Kort, forhåndsdefinert tekst som sier noe om grunnlaget for permisjonen.',
            prosent: 'Hvor mange prosent permisjonen utgjør av den avtalte stillingsprosenten til arbeidstakeren.',
            id: 'Identifikator som er unik for permisjonen innenfor arbeidsforholdet. Arbeidsgiveren må bruke en ny identifikator ved en senere permisjon, eller ved permisjoner som overlapper i tid.',
        },
        permittering: {
            periode:
                'Perioden arbeidsgiveren har permittert arbeidstakeren. Perioden starter når permitteringen er iverksatt, som regel første lønnspliktdag.',
            type: 'Kort, forhåndsdefinert tekst som sier noe om grunnlaget for permitteringen.',
            prosent: 'Hvor mange prosent permitteringen utgjør av den avtalte stillingsprosenten til arbeidstakeren.',
            id: 'Identifikator som er unik for permitteringen innenfor arbeidsforholdet. Arbeidsgiveren må bruke en ny identifikator dersom arbeidstakeren blir permittert på nytt senere.',
        },
        timerForTimeloennet: {
            rapporteringsmaaned: 'Måneden opplysningen er rapportert for. Den er ikke nødvendigvis den samme som opptjeningsperioden.',
            opptjeningsperiode: 'Perioden timene ble arbeidet i. Oppgis bare når arbeidsgiveren har rapportert den.',
            antallTimer:
                'Antall arbeidstimer som ligger til grunn for utbetaling av lønn til en ansatt med timelønn. Timer opptjent som overtid inngår ikke i Aa-registeret.',
        },
        utenlandsopphold: {
            rapporteringsmaaned: 'Måneden opplysningen er rapportert for. Den er ikke nødvendigvis den samme som opptjeningsperioden.',
            opptjeningsperiode: 'Perioden inntekten ble opptjent i. Oppgis bare når arbeidsgiveren har rapportert den.',
            land: 'Landet arbeidstakeren har opptjent inntekt i.',
        },
    },

    footer: {
        informasjon: 'Informasjon om tjenesten',
        driftsvarsler: 'Nyheter og driftsvarsler',
        driftsvarslerBeskrivelse: 'Endringer i tjenesten og varsler om planlagt eller uventet nedetid.',
        brukerstoette: 'Brukerstøtte',
        brukerstoetteHeading: 'Faglige, funksjonelle eller tekniske spørsmål til Aa-registeret',
        faqBefore: 'Før du sender faglige, funksjonelle eller tekniske spørsmål i brukerstøttetjenesten, må du sjekke vanlige ',
        faqLink: 'spørsmål og svar',
        faqAfter: '.',
        dokumentasjonBefore: 'Se også ',
        dokumentasjonLink: 'faglig og teknisk beskrivelse av tjenestene',
        dokumentasjonAfter: ' (Github).',
        naarKontakte: 'Hvis du ikke finner svar på spørsmålene dine, kan du kontakte brukerstøtte når du:',
        kontaktPunkt1: 'Har faglige, funksjonelle og tekniske spørsmål om Aa-registeret og innsynsløsningen',
        kontaktPunkt2: 'Har tips om uriktige eller manglende opplysninger i registeret',
        kontaktPunkt3: 'Vil varsle om feil eller sikkerhetsbrudd i innsynstjenesten',
        kontaktPunkt4: 'Vil melde om endringsønsker',
        tilgangMerknad: 'NB! Spørsmål om å søke tilgang til Aa-registeret gjelder ikke for arbeidsgivere og arbeidstakere.',
        merInformasjonLink: 'Her finner du mer informasjon om Arbeidsgiver- og arbeidstakerregisteret',
        arbeidstaker: {
            regionLabel: 'Hjelp og informasjon',
            informasjonBeskrivelse: 'Hva oversikten viser, hvem som eier Aa-registeret og hva Nav bruker opplysningene til.',
            brukerstoetteBeskrivelse: 'Spørsmål og svar, og hva du gjør hvis det er feil i opplysningene om arbeidsforholdene dine.',
            informasjonAvsnitt1:
                'Oversikten viser alle arbeidsforhold rapportert etter 01.01.2015, slik arbeidsgiver har rapportert. Hvis det er feil i et arbeidsforhold, kan arbeidsgiveren endre gjennom a-meldingen.',
            informasjonAvsnitt2:
                'Nav trenger informasjon om arbeidsforholdene dine for å kunne vurdere behovet ditt for oppfølging og tjenester fra Nav, og til å beregne hvor mye du kan få utbetalt i for eksempel sykepenger, dagpenger og foreldrepenger. Andre offentlige etater har også tilgang til opplysninger fra Arbeidsgiver- og arbeidstakerregisteret.',
            informasjonAvsnitt3:
                'Det er Arbeids- og velferdsetaten som eier og forvalter Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret).',
            feilHeading: 'Feil i opplysninger om dine arbeidsforhold?',
            feilAvsnitt1:
                'Hvis det er feil i opplysninger om dine arbeidsforhold i Arbeidsgiver- og arbeidstakerregisteret, må du kontakte arbeidsgiveren som kan endre gjennom a-meldingen.',
            feilAvsnitt2: 'Dersom arbeidsgiver ikke kan hjelpe deg, kan du kontakte Navs brukerstøtte for Aa-registeret.',
        },
        arbeidsgiver: {
            regionLabel: 'Hjelp og informasjon',
            informasjonBeskrivelse: 'Hva oversikten viser, hvordan du retter feil gjennom a-meldingen og hva Nav bruker opplysningene til.',
            brukerstoetteBeskrivelse: 'Har du spørsmål om Aa-registeret, a-meldingen eller pålogging til tjenesten?',
            informasjonAvsnitt1:
                'Oversikten viser alle arbeidsforhold rapportert etter 01.01.2015 for valgt virksomhet. Hvis du finner feil i oversikten, skal du som arbeidsgiver endre dette gjennom a-meldingen.',
            aMeldingBefore: 'Se ',
            aMeldingLink: 'Skatteetatens veiledning til a-meldingen',
            aMeldingAfter: '.',
            informasjonAvsnitt2:
                'Nav trenger informasjon om arbeidsforholdene for å kunne vurdere behovet for oppfølging og tjenester fra Nav, og til å beregne hvor mye dine arbeidstakere kan få utbetalt i for eksempel sykepenger, dagpenger og foreldrepenger. Andre offentlige etater har også tilgang til opplysninger fra Arbeidsgiver- og arbeidstakerregisteret.',
            informasjonAvsnitt3:
                'Det er Arbeids- og velferdsetaten som eier og forvalter Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret).',
            brukerstoette: {
                altinnHeading: 'Har du spørsmål knyttet til Altinn-rettighet for tjenesten eller pålogging via Altinn',
                altinnBefore:
                    'Dersom du har spørsmål knyttet til delegering av altinn-rettigheten «Innsyn i Arbeidsgiver- og arbeidstakerregisteret (Aa-registeret) for arbeidsgivere» eller pålogging, kan du ',
                altinnLink: 'få hjelp hos Altinn',
                altinnAfter: ' (',
                altinnKildeLink: 'Altinn.no',
                altinnKildeAfter: ').',
                aMeldingHeading: 'Hvordan rapportere arbeidsforhold til Aa-registeret via a-meldingen?',
                aMeldingBefore:
                    'Har du spørsmål knyttet til hvordan du rapporterer arbeidsforhold eller foretar korrigeringer, kan du finne nærmere informasjon i ',
                aMeldingVeiledningLink: 'veiledningen til a-meldingen',
                aMeldingMellom: ', eller ',
                aMeldingKontaktLink: 'kontakte a-ordningen',
                aMeldingAfter: ' (',
                aMeldingKildeLink: 'Skatteetaten.no',
                aMeldingKildeAfter: ').',
                andreHeading: 'Andre spørsmål om Aa-registeret',
                andreBefore:
                    'Du finner nærmere informasjon om hva Aa-registeret er, meldeplikt til registeret, hvilken informasjon som finnes i registeret, og hvem som kan motta opplysninger fra registeret på denne siden ',
                andreLink: 'om Aa-registeret på nav.no',
                andreMellom: ' eller ',
                andreKontaktLink: 'kontakte Nav registerforvaltning',
                andreAfter: '.',
            },
        },
        samarbeidspartner: {
            regionLabel: 'Hjelp og kontakt',
            kontaktKnapp: 'Kontakt Aa-registeret',
            brukerveiledning: 'Brukerveiledning (pdf)',
            brukerveiledningBeskrivelse: 'Steg for steg gjennom web-oppslag i Aa-registeret.',
            tips: 'Tips om manglende eller uriktige opplysninger',
            tipsBeskrivelse: 'Hva du bør tipse om, hva et godt tips inneholder og hvordan du sender det inn.',
            brukerstoetteLenke: 'Faglig, funksjonell eller teknisk brukerstøtte',
            brukerstoetteBeskrivelse: 'Spørsmål og svar, teknisk beskrivelse av tjenestene og når du bør kontakte brukerstøtte.',
            kontaktPunkt1: 'Har tips om uriktige eller manglende opplysninger i registeret',
            kontaktPunkt2: 'Har faglige, funksjonelle og tekniske spørsmål om Aa-registeret og distribusjonsløsningene',
            kontaktPunkt3: 'Vil melde om endringsønsker',
            kontaktPunkt4: 'Vil varsle om feil eller sikkerhetsbrudd i innsynstjenesten',
            kontaktPunkt5: 'Har spørsmål om å søke tilgang til Aa-registeret',
            klikkBefore: 'Klikk på ',
            klikkLink: '«Kontakt Aa-registeret»',
            klikkAfter: ' og oppgi kategorien du mener passer best. Det er ikke kritisk om du velger feil kategori.',
            beskrivHenvendelse:
                'Beskriv henvendelsen best mulig. Du kan også laste opp vedlegg om det er viktig for å belyse henvendelsen.',
            tipsHeading: 'Tips om uriktige eller manglende opplysninger i registeret',
            tipsIntro:
                'Hvis du ser uriktige eller manglende opplysninger i registeret, ønsker vi at du tipser oss om dette gjennom Navs brukerstøtteløsning.',
            tipsEksemplerIntro: 'Eksempler på hva det kan tipses om:',
            tipsEksempel1: 'Feil eller manglende start- og/eller sluttdato',
            tipsEksempel2: 'Arbeidsforhold er ikke rapportert, men skulle vært det',
            tipsEksempel3: 'Mistanke om at det foreligger fiktive arbeidsforhold',
            tipsEksempel4: 'Manglende eller feil rapportering av permisjon/permittering',
            tipsEksempel5: 'Feil stillingsprosent',
            tipsEksempel6: 'Manglende rapportering av inntekt, men arbeidsforhold er rapportert',
            tipsInnholdIntro: 'Et godt tips om mulig uriktige eller manglende opplysninger i Aa-registeret må inneholde:',
            tipsInnhold1: 'Navn og fødsels- og personnummer til den det gjelder',
            tipsInnhold2: 'Hvem er arbeidsgiver (organisasjonsnummer)',
            tipsInnhold3: 'Dato for når forholdet ble avdekket/oppdaget',
            tipsInnhold4: 'Bakgrunnen for tipset',
            tipsInnhold5: 'All dokumentasjon/info som understøtter grunnlaget for tipset som dere har lov til å dele',
            tipsInnhold6: 'Informasjon om det foreligger arbeidsavtale, timelister?',
            tipsInnhold7: 'Annen informasjon som tilsier at vedkommende arbeider der',
            tipsInnhold8: 'Vurdering av hvor sannsynlig det er at det foreligger et reelt arbeidsforhold',
            tipsInnhold9: 'Har dere gitt noe informasjon til arbeidsgiver? Hva?',
            tipsKlikk:
                'Klikk på «Kontakt Aa-registeret» og velg kategorien «Tips om uriktige eller manglende opplysninger i registeret» i emnefeltet, og oppgi informasjon og eventuelle vedlegg.',
            tipsPostBefore: 'Hvis du ikke kan bruke brukerstøtteløsningen, kan du sende tips via: ',
            tipsPostLink: 'Send i posten',
            tipsPostAfter:
                '. Dette krever ikke innlogging. I neste steg velger du «Flere personer samtidig eller tiltaksbedrifter, kursarrangører og andre virksomheter» under hvem innsendingen gjelder, og Nav registerforvaltning som mottakende enhet.',
        },
    },
}
